import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { connect } from "react-redux";
import Modal from "react-modal";

import { closeModal } from "../../../actions";
import { loginUser } from "../../../actions/userActions";
import { getAllCategories } from "../../../actions/categoryActions";

const customStyles = {
  content: {
    top: "50%",
    transform: "translateY(-50%)",
  },
  overlay: {
    backgroundColor: "rgba(77,77,77,0.6)",
    zIndex: "10000",
  },
};

Modal.setAppElement("#root");

function LoginModal(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { showModal, modal } = props;
  let timer;

  function closeModal() {
    document
      .getElementById("login-modal")
      .classList.remove("ReactModal__Content--after-open");

    timer = setTimeout(() => {
      props.closeModal("login");
    }, 200);
  }

  useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
  });

  function loginUserForm() {
    props.loginUser(email, password);
  }

  return (
    <Modal
      isOpen={showModal && "login" === modal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Login Modal"
      className="modal-dialog modal-dialog-centered"
      id="login-modal"
    >
      <div className="modal-content">
        <div className="modal-body">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}
          >
            <span aria-hidden="true">
              <i className="icon-close"></i>
            </span>
          </button>
          <div className="form-box">
            <div className="form-tab">
              <Tabs selectedTabClassName="show" defaultIndex={0}>
                <TabList className="nav nav-pills nav-fill">
                  <Tab className="nav-item">
                    <span className="nav-link">S'identifier</span>
                  </Tab>

                  {/*
                                    <Tab className="nav-item">
                                        <span className="nav-link">Register</span>
                                    </Tab>
                                    */}
                </TabList>

                <div className="tab-content">
                  <TabPanel style={{ paddingTop: "2rem" }}>
                    <div>
                      {/*</div><form onSubmit={(e) => {e.preventDefault(); loginUser(email, password); }}>*/}
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          loginUserForm();
                          closeModal();
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="singin-email-2">
                            Nom d'utilisateur *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="singin-email-2"
                            name="username"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="singin-password-2">
                            Mot de passe *
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="singin-password-2"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            className="btn btn-outline-primary-2"
                          >
                            <span>Se Connecter</span>
                            <i className="icon-long-arrow-right"></i>
                          </button>
                          {/*<div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="signin-remember-2" />
                                                        <label className="custom-control-label" htmlFor="signin-remember-2">Rester connecté</label>
                                                    </div>

                                                    <Link to="#" className="forgot-link">Mot de pass oublié ?</Link>*/}
                        </div>
                      </form>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

function mapStateToProps(state) {
  return {
    showModal: state.modal.showModal,
    modal: state.modal.modal,
  };
}

export default connect(mapStateToProps, {
  closeModal,
  loginUser,
  getAllCategories,
})(LoginModal);
